import backendRequest from "./index.js";

const send = (email, title, message, trainings = false) =>
    backendRequest("POST", `/contact/send`, { email, title, message, trainings });

export { send };
